import type { RateAccessorialsFormType } from '../../types';
import type { ModelGetInitialQuoteAccessorials } from './api';

export const normalizeInitialQuoteAccessorials = (
  data: ModelGetInitialQuoteAccessorials,
): RateAccessorialsFormType[] => {
  if (!data) {
    return [];
  }

  return data.map((value) => ({
    _key: crypto.randomUUID(),
    accessorialCode: value.accChargeType,
    accessorialDescription: value.codeDesc,
    isAccessorialCheckboxDisabled: Boolean(value.isChecked),
    isAccessorialSelectDisabled: true,
    isActive: Boolean(value.isChecked),
  }));
};
